// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__11jdc","header":"Messages_header__32a9U"};